export default __webpack_public_path__ + "static/openvas-f5d25a8f83c1a8a800f156f8bbb99338.png";